import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { GridModule } from '@angular/flex-layout/grid';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';

import { MgEmptyStateModule } from '@app/src/app/components/EmptyState';
import { MgIconModule } from '@app/src/app/icon';
import { MgPipesModule } from '@app/src/app/pipes';
import { DayjsPipesModule } from '@app/src/app/shared/pipes/dayjs/dayjs-pipes.module';
import { MgSpinnerModule } from '@app/src/app/spinner';

import { CountTileModule } from '@shared/components/count-tile';
import { FormModule } from '@shared/components/form';
import { GenericModule } from '@shared/components/generic';
import { ManagerOverlayModule } from '@shared/components/manager-overlay';
import { TextModule } from '@shared/components/text/text.module';
import { TilesCarouselModule } from '@shared/components/tiles-carousel';
import { CommonPipesModule } from '@shared/modules';

import { FtmSharedModule } from '../ftm-shared/ftm-shared.module';
import { FtmDashboardComponent } from './ftm-dashboard.component';
import {
  CalculateStudentCheckedInPipe,
  GetButtonStatusColorPipe,
  GetPeriodStatusPipe,
  GetStudentRegisteredPipe,
} from './pipes';
import { FtmDashboardService } from './services';

@NgModule({
  imports: [
    // Minga dependencies
    ManagerOverlayModule,
    MgIconModule,
    TilesCarouselModule,
    MgSpinnerModule,
    MgEmptyStateModule,
    CountTileModule,
    FtmSharedModule,
    FormModule,
    TextModule,
    MatCheckboxModule,
    GenericModule,
    CommonPipesModule,
    MgPipesModule,
    DayjsPipesModule,
    MatTooltipModule,

    // External dependencies
    CommonModule,
    FlexLayoutModule,
    GridModule,
  ],
  declarations: [
    FtmDashboardComponent,
    GetStudentRegisteredPipe,
    CalculateStudentCheckedInPipe,
    GetPeriodStatusPipe,
    GetButtonStatusColorPipe,
  ],
  exports: [FtmDashboardComponent],
  providers: [FtmDashboardService],
})
export class FtmDashboardModule {}
